<app-top-navigation backLinkPath="/">
  <span title>Solicitações - Alteração de benefícios</span>
</app-top-navigation>
<aside
  class="sidebar"
  #container
  [ngClass]="{'slide-menu-active': showSidebar}"
  (click)="toggleMenu()"
>
  <div
    (click)="$event.stopImmediatePropagation();"
    class="sidebar-wrapper-menu"
    [ngClass]="{'wrapper-menu-active': showSidebar}"
  >
    <div class="sidebar-menu">
      <div class="header-sidebar">
        <h3>Configurar Exportação</h3>
        <button type="button" aria-label="Fecha menu lateral" (click)="toggleMenu()"></button>
      </div>
      <div *ngIf="columns.length > 0 else loadingOrError" class="sidebar-content">
        <div>
          <div class="main-sidebar">
            <div class="column-header">
              <h4>Colunas</h4>
              <label [attr.aria-label]="'Quantidade de colunas ativas ' + activeColumns" class="column-count-label" data-test="count-active-columns">{{ activeColumns }}</label>
            </div>
            <div class="columns-list">
              <ul *ngFor="let column of columns">
                <li class="switch-container">
                  <div class="switch">
                      <input
                        id="column-{{ column.Name }}"
                        class="cmn-toggle cmn-toggle-round"
                        data-test="column-toggle"
                        [attr.aria-label]="column.I18n"
                        type="checkbox"
                        (change)="toggleColumn(column)"
                        [value]="column.Active"
                        [checked]="column.Active">
                      <label for="column-{{ column.Name }}"></label>
                  </div>
                  <p class="toogle-guia">{{ column.I18n }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="sidebar-footer">
          <button  class="btn-collaborators" (click)="exportReport()" [disabled]="loadingReport" data-test="download-report">
            <img src="/assets/images/ico-download.svg" alt="baixar relatório"/>
            Baixar relatório
            <img *ngIf="loadingReport" src="/assets/images/core/spinner-white.svg" alt="carregando solicitação de relatório"/>
          </button>
        </div>
      </div>
      <ng-template #loadingOrError>
        <div *ngIf="error$ | async as error; else loading" class="sidebar-error">
          <up-feature-status-error [code]="error?.status"></up-feature-status-error>
        </div>
        <ng-template #loading>
          <div class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </ng-template>
      </ng-template>
    </div>
  </div>
</aside>
<alert></alert>
<mat-card class="card-container">
  <div class="card-header">
    <h4 class="card-title">Documentos</h4>
    <up-search-collaborator (emitQuerySearch)="search($event)"></up-search-collaborator>

  </div>
  <mat-card-content>

    <mat-divider></mat-divider>

    <div class="card-content">
    <mat-form-field>
      <mat-date-range-input [formGroup]="range" [rangePicker]="rangePicker">
        <input matStartDate formControlName="start" placeholder="Start date">
        <input matEndDate formControlName="end" placeholder="End date">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
      <mat-date-range-picker #rangePicker>
        <mat-date-range-picker-actions>
          <button mat-button matDateRangePickerCancel>Cancelar</button>
          <button mat-raised-button color="primary" matDateRangePickerApply  (click)="searchBenefitsChangesRequests()">Aplicar</button>
        </mat-date-range-picker-actions>
      </mat-date-range-picker>
    </mat-form-field>
    <div class="button-group">
      <button mat-raised-button class="button-stroked" (click)="rangePicker.open()">
        <span>
          <mat-icon svgIcon="calendar_icon" aria-hidden="false" aria-label="Ícone de calendario"></mat-icon>
          Selecione o período
        </span>
      </button>
      <button type="button" class="button-stroked" data-test="export-button" aria-label="Abre menu lateral configurações de exportação" (click)="toggleMenu()">
        <span>
          <mat-icon svgIcon="download_icon" aria-hidden="false" aria-label="Ícone de download"></mat-icon>
          Exportar
        </span>
      </button>
    </div>
    </div>
    <div>
      <mat-tab-group animationDuration="0ms" (selectedTabChange)="changeTab($event)">
        <!-- List of completed -->
        <mat-tab>
          <ng-template mat-tab-label>
            <span class="label-header">
              <mat-icon svgIcon="check_icon" aria-hidden="false" aria-label="Ícone de check"></mat-icon>
              Concluídos
            </span>
          </ng-template>
          <ng-container *ngIf="list$ | async as lists; else loadingOrError">
            <div *ngIf="lists?.length; else noItems">
              <unico-people-request-list
                [dataSource]="lists"
                [displayedColumns]="displayedColumns"
                [concluded]="true"
                [paginator]="paginator"
              ></unico-people-request-list>
            </div>
          </ng-container>
        </mat-tab>
        <!-- Pending List -->
        <mat-tab>
          <ng-template mat-tab-label class="tab-label">
            <span class="label-header">
              <mat-icon svgIcon="clock_icon" aria-hidden="false" aria-label="Ícone de relógio"></mat-icon>
                Pendentes de assinatura
            </span>
          </ng-template>
          <ng-container *ngIf="list$ | async as lists; else loadingOrError">
            <div *ngIf="lists?.length; else noItems">
              <unico-people-request-list
                [dataSource]="lists"
                [displayedColumns]="displayedColumns"
                [pending]="true"
                [paginator]="paginator"
              ></unico-people-request-list>
            </div>
          </ng-container>
        </mat-tab>
      </mat-tab-group>
      <ng-template #loadingOrError>
        <div *ngIf="error$ | async as error; else loading" class="home-loading error-loading">
          <up-feature-status-error [code]="error?.status"></up-feature-status-error>
        </div>
        <ng-template #loading>
          <div class="spinner" data-test="loading">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </ng-template>
      </ng-template>
      <ng-template #noItems class="list-empty animated fadeInDown">
       <div class="list-empty-container">
          <div class="list-empty__image">
            <img src="/assets/images/ilustras-Skill.svg" alt="Nenhuma solicitação encontrada">
          </div>
          <div class="list-empty__infos" data-test="listEmpty">
            <h3 data-test="titleListEmpty">Não há nenhuma solicitação</h3>
          </div>
       </div>
      </ng-template>
    </div>
    <div class="pagination-container">
      <up-feature-pagination
        [newBrand]="true"
        [limit]="paginator.limit"
        [total]="paginator.total"
        (pageChange)="getPage($event)"
        (limitChange)="getPageForLimit($event)"
      ></up-feature-pagination>
    </div>
  </mat-card-content>

</mat-card>
